export const mapCompilationFormData = (data, media) => ({
  title: data?.title,
  autoInclude: data?.autoInclude,
  ctaLabel: data?.ctaLabel,
  ctaLink: data?.ctaLink,
  ctaDescription: data?.ctaDescription,
  websiteLink: data?.websiteLink,
  enabled: data?.enabled || true,
  sort: data?.sort || 'RANDOM',
  primaryColor: data?.primaryColor,
  content: contentMapper(media || data?.media),
  logoUrl: data?.logoUrl,
});

const contentMapper = (media) => media?.map((m) => m?.id);



// WEBPACK FOOTER //
// ./src/helpers/compilationHelper.js